import FilterTextInput from "../FilterTextInput";
import {
  Clock,
  TickCircle,
} from "iconsax-react";
import { motion as m } from "framer-motion";
import Paginator from "../Paginator";
import DropdownSet from "../DropdownSet";

const ReportTable = ({
  data,
  meta,
  handlePageClick,
  handleSearch,
  handleKeyDown,
  searchTerm,
  selectedStatus,
  statusOptions,
  handleChangeStatus,
  perPage,
  handlePerPageChange,
  clearFilter,
}) => {
  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {/* {clearFilter && searchTerm != "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )} */}
        {statusOptions && (
          <DropdownSet
            options={statusOptions}
            label="Status"
            name="status"
            value={selectedStatus}
            hiddenLabel
            onChange={(name, value) => {
              handleChangeStatus(value);
            }}
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Table data */}
      <div className="flex w-full h-full gap-[24px] no-scrollbar overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No guests found
          </div>
        ) : (
          <table className="w-full h-full text-nowrap">
            {/* Table Header */}
            <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
              <th className="text-start px-[24px] py-[16px]">Guest</th>
              <th className="text-start px-[24px] py-[16px]">Table</th>
              <th className="text-start px-[24px] py-[16px]">
                Check-In Status
              </th>
            </tr>

            {/* Table Body */}
            {data &&
              data.map((item) => (
                <tr
                  key={item.id}
                  className="w-full font-normal border-b last:border-none border-[#EFF0F2]"
                >
                  <td className="px-[24px] py-[16px]">{item.guest ?? "-"}</td>
                  <td className="px-[24px] py-[16px]">{item.table ?? "-"}</td>
                  <td className="px-[24px] py-[16px]">
                    {item.status === true ? (
                      <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#F4FCF7] border border-[#E9F9EF] text-[#22C55E]">
                        <TickCircle size="16" variant="Bold" />
                        Checked
                      </div>
                    ) : (
                      <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#FFFBF3] border border-[#FEF6E6] text-[#F0A009]">
                        <Clock size="16" variant="Bold" />
                        Pending
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </table>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
          handlePageClick={handlePageClick}
        />
      )}
    </m.div>
  );
};

export default ReportTable;
